import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './views/Login';
import Dashboard from './views/Dashboard';
import DashboardMobile from './views/DashboardMobile';
import CustomersMobile from './views/CustomersMobile';
import CustomerDetailMobile from './views/CustomerDetailMobile';
import Customers from './views/Customers';
import CustomerDetail from './views/CustomerDetail';
import Payments from './views/Payments';
import PaymentsMobile from './views/PaymentsMobile';
import ProtectedRoute from './components/ProtectedRoute';
import MainLayout from './components/MainLayout';
import MainLayoutMobile from './components/MainLayoutMobile';
import PlaceholderPage from './components/PlaceholderPage';
import { SidebarProvider } from './contexts/SidebarContext';
import { isMobileDevice } from './utils/deviceDetection';

// 루트 리다이렉트 컴포넌트 - 디바이스 타입에 따라 적절한 라우트로 리다이렉트
const RootRedirect: React.FC = () => {
  // 모바일 디바이스인 경우 모바일 대시보드로, 그렇지 않으면 웹 대시보드로 리다이렉트
  if (isMobileDevice()) {
    return <Navigate to="/mobile/dashboard" replace />;
  }
  return <Navigate to="/dashboard" replace />;
};

// 메인 App 컴포넌트
const App: React.FC = () => {
  return (
    <SidebarProvider>
      <Router>
        <Routes>
          {/* 로그인 페이지 (인증 불필요) */}
          <Route path="/login" element={<Login />} />

          {/* 루트 경로 - 웹 대시보드로 리다이렉트 */}
          <Route path="/" element={
            <ProtectedRoute>
              <RootRedirect />
            </ProtectedRoute>
          } />

          {/* 데스크톱 보호된 라우트들 (인증 필요) */}
          <Route path="/" element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }>
            {/* 대시보드 */}
            <Route path="dashboard" element={<Dashboard />} />

            {/* 고객 관리 */}
            <Route path="customers" element={<Customers />} />
            <Route path="customers/:userIdx" element={<CustomerDetail />} />

            {/* 결제 관리 */}
            <Route path="payments" element={<Payments />} />

            {/* 설정 — OverlaySidebar(`/settings`)와 정합; 플레이스홀더만 */}
            <Route
              path="settings"
              element={
                <PlaceholderPage
                  title="설정"
                  description="시스템 설정 페이지가 여기에 표시됩니다."
                />
              }
            />

            {/* 키워드 관리 (추후 구현) */}
            <Route
              path="keywords"
              element={
                <PlaceholderPage
                  title="키워드 관리"
                  description="키워드 관리 페이지가 여기에 표시됩니다."
                />
              }
            />

            {/* 상품 관리 (추후 구현) */}
            <Route
              path="products"
              element={
                <PlaceholderPage
                  title="상품 관리"
                  description="상품 관리 페이지가 여기에 표시됩니다."
                />
              }
            />
          </Route>

          {/* 모바일 보호된 라우트들 (인증 필요) */}
          <Route path="/mobile" element={
            <ProtectedRoute>
              <MainLayoutMobile />
            </ProtectedRoute>
          }>
            {/* 모바일 대시보드 */}
            <Route path="dashboard" element={<DashboardMobile />} />

            {/* 모바일 고객 관리 */}
            <Route path="customers" element={<CustomersMobile />} />
            <Route path="customers/:userIdx" element={<CustomerDetailMobile />} />

            {/* 모바일 결제 관리 */}
            <Route path="payments" element={<PaymentsMobile />} />

            {/* 모바일 설정 */}
            <Route
              path="settings"
              element={
                <PlaceholderPage
                  shell="mobile"
                  title="설정"
                  description="모바일 시스템 설정 페이지가 여기에 표시됩니다."
                />
              }
            />

            {/* 모바일 키워드 관리 (추후 구현) */}
            <Route
              path="keywords"
              element={
                <PlaceholderPage
                  shell="mobile"
                  title="키워드 관리"
                  description="모바일 키워드 관리 페이지가 여기에 표시됩니다."
                />
              }
            />

            {/* 모바일 상품 관리 (추후 구현) */}
            <Route
              path="products"
              element={
                <PlaceholderPage
                  shell="mobile"
                  title="상품 관리"
                  description="모바일 상품 관리 페이지가 여기에 표시됩니다."
                />
              }
            />
          </Route>

          {/* 404 페이지 - 모든 경로가 매칭되지 않을 때 */}
          <Route path="*" element={<RootRedirect />} />
        </Routes>
      </Router>
    </SidebarProvider>
  );
};

export default App; 